module.exports = typeof window == 'object';



// WEBPACK FOOTER //
// webpack://vueperslides/node_modules/core-js/internals/engine-is-browser.js